module.exports = __webpack_public_path__ + "static/img/home_case_bg2_zh.8712a2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_case_bg2_zh.png
// module id = kUf0
// module chunks = 34